import RequestUtils from "utils/RequestUtils";

export default class LineSettingApi {
  private constructor() {}

  public static async find(companyId: number) {
    return await RequestUtils.getPlain(`/lineSetting/find/${companyId}`);
  }

  public static async update(
    companyId: number,
    data: {
      lineChannelAccessToken?: string;
      lineChannelSecret?: string;
      lineNotifyEnabled?: boolean;
      lineBotBasicId?: string;
      staffNotificationEmail?: string | null;
    }
  ) {
    return await RequestUtils.postPlain(
      `/lineSetting/update/${companyId}`,
      data
    );
  }
}
